var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{directives:[{name:"b-scrollspy",rawName:"v-b-scrollspy:nav-scroller",arg:"nav-scroller"}],staticClass:"header-area is-sticky",attrs:{"toggleable":"xl","fixed":"top"}},[_c('NavBarHeader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }